import React from 'react';
import { Carousel, Button } from 'react-bootstrap';

function ModernCarousel({ items, styles = {} }) {
    const {
        headline = {},
        caption = {},
        image = {},
        button = {}
    } = styles || {};

    // Destructure link from button style, and gather the remaining styles in buttonStyles.
    const { link: buttonLinkStyle, ...buttonStyles } = button;

    return (
        <Carousel className="slider-container modern-slider">
            {items && items.length > 0 ? (
                items.map((item, index) => (
                    <Carousel.Item key={index}>
                        <img
                            className="d-block w-100"
                            src={item.src}
                            alt={item.alt || `Slide ${index + 1}`}
                            style={{ 
                                objectFit: 'cover', 
                                height: '500px', 
                                ...image 
                            }}     
                        />
                        <Carousel.Caption>
                            <div>
                                {item.alt && <h1 style={headline}><b>{item.alt}</b></h1>}
                                {item.caption && <p style={caption}>{item.caption}</p>}
                                {item.buttonText && (
                                    <Button
                                        variant="primary"
                                        // Use item.buttonLink if available; otherwise fallback to buttonLinkStyle, and finally '#'
                                        href={item.buttonLink || buttonLinkStyle || '#'}
                                        style={buttonStyles}
                                    >
                                        {item.buttonText}
                                    </Button>
                                )}
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>
                ))
            ) : (
                <div>No items to display</div>
            )}
        </Carousel>
    );
}

export default ModernCarousel;
